import React, {ChangeEventHandler, FC} from "react"
import Textarea from "../elements/Textarea"
import {useFormData} from "../../states/FormData"

const Step2: FC = () => {
    const {setFormData, textareaValue} = useFormData()

    const handleTextareaChange: ChangeEventHandler<HTMLTextAreaElement> = (event) => {
        console.log('huhu')
        setFormData("textareaValue", event.target.value)
    }


    return (
        <div>
            <span className={"survey-heading"}>Hast du konkrete Fragen zur  richtigen Ernährung in deiner aktuellen Situation?</span>
            <Textarea placeholder={"Ich würde gerne wissen..."} value={textareaValue} onChange={handleTextareaChange} />
        </div>
    )
}
export default Step2